export default {
  "content": "<g clip-path=\"url(#clip0_3375_60087)\"><path d=\"M22.99 8.635c-.705-4.16-4.193-7.44-8.385-7.904C8.83.09 3.933 4.603 3.933 10.267c0 1.744.48 3.392 1.296 4.8l6.64 10.271c.784 1.216 2.576 1.216 3.36 0l6.624-10.272h-.016a9.528 9.528 0 001.152-6.431zm-9.457 6.431a4.794 4.794 0 01-4.8-4.8c0-2.655 2.144-4.8 4.8-4.8 2.656 0 4.8 2.145 4.8 4.8 0 2.656-2.144 4.8-4.8 4.8z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_3375_60087\"><path fill=\"#fff\" transform=\"translate(.733 .666)\" d=\"M0 0h25.6v25.6H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "27",
    "height": "27",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};